import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './authInterceptor/auth.interceptor';
import { ErrorInterceptor } from './error/error.interceptor';

export const _HTTPInterceptorsProviders =[
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
];
